import * as Inovx from '@shared';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/Taxonomy`;

const TaxonomyServices = { ...Inovx.Shared.Flux.BaseService,
    getAll: function () {
        return new Promise<ILibraryTaxonomyDetail[]>((resolve, reject) => {

             this.get(url,
                 null,
                 (retData: ILibraryTaxonomyDetail[]) => {
                     resolve(retData)
                 },
                 (error: IServiceErrorObject) => {
                     this.handleWebApiError(error);
                     reject(error);
                 }
             );
        });
    },
    create: function (data: { Name: string, Type: number }) {
        return new Promise<ILibraryTaxonomyDetail>((resolve, reject) => {
            this.post(`${url}/Create`,
                data,
                (retData: ILibraryTaxonomyDetail) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    update: function (data: ILibraryTaxonomyDetail) {
        return new Promise<ILibraryTaxonomyDetail>((resolve, reject) => {
            this.post(`${url}/Update`,
                data,
                (retData: ILibraryTaxonomyDetail) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    try {
                        const errJson = JSON.parse(error.responseText);
                        if (errJson.Reason === "ObjectCannotBeDeleted") {
                            reject({ handled: false, reason: errJson.Reason });
                            return;
                        }
                    }
                    catch { }

                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getTaxonomyDetail: function (Id: string) {
        return new Promise<ILibraryTaxonomyDetail>((resolve, reject) => {
            this.get(`${url}/Detail`,
                { id: Id },
                (retData: ILibraryTaxonomyDetail) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getVisibleTaxonomyDetail: function (Id: string) {
        return new Promise<ILibraryTaxonomyDetail>((resolve, reject) => {
            this.get(`${url}/Detail/Visible`,
                { id: Id },
                (retData: ILibraryTaxonomyDetail) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getDeleteValidation: function (Id: string) {
        return new Promise<ITaxonomyDeleteValidation>((resolve, reject) => {
            this.get(`${url}/Delete/Validation`,
                { id: Id },
                (retData: ITaxonomyDeleteValidation) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getClassificationTagDeleteValidation: function (taxonomyId: string, classificationTagId: string) {
        return new Promise<IClassificationTagDeleteValidation>((resolve, reject) => {
            this.get(`${url}/ClassificationTag/Delete/Validation`,
                { taxonomyId, classificationTagId },
                (retData: IClassificationTagDeleteValidation) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    deleteTaxonomy: function (taxonomy: ITaxonomy) {
        return new Promise<void>((resolve, reject) => {
            this.post(`${url}/Delete`,
                taxonomy,
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    try {
                        var errJson = JSON.parse(error.responseText);
                        if (errJson.Reason === "ObjectCannotBeDeleted") {
                            reject({ handled: false, reason: errJson.Reason });
                            return;
                        }
                    }
                    catch { }

                    this.handleWebApiError(error);
                    reject({ handled: true });
                }
            );
        });
    }
};

export default TaxonomyServices;
